import { useReduxState } from 'hooks';
import {
  CartesianGrid,
  LineChart as RechartsLineChart,
  Line,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip
} from 'recharts';

type LineProps =
  | { lineColors?: string; yAxisDataKey: string }
  | { lineColors: string[]; yAxisDataKey: string[] };

type CommonProps = {
  accessibilityLayer?: boolean;
  data: any;
  height?: number;
  xAxisDataKey: string;
};

const LineChart = ({
  accessibilityLayer = false,
  data,
  height = 300,
  lineColors,
  xAxisDataKey,
  yAxisDataKey
}: CommonProps & LineProps) => {
  const { theme } = useReduxState();

  const yAxis = Array.isArray(yAxisDataKey) ? yAxisDataKey : [yAxisDataKey];

  const lineColor = Array.isArray(lineColors)
    ? lineColors
    : [lineColors || theme.chartMainColor];

  return (
    <div className="line-chart" style={{ height, width: '100%' }}>
      <ResponsiveContainer>
        <RechartsLineChart
          accessibilityLayer={accessibilityLayer}
          data={data}
          margin={{ top: 20, right: 10, left: 10, bottom: 10 }}
        >
          <CartesianGrid
            stroke={theme.lightGreyDarkActive}
            strokeDasharray="5 7"
            vertical={false}
          />

          <Tooltip
            animationDuration={200}
            contentStyle={{
              border: 0,
              borderRadius: 5,
              boxShadow: '0 1px 5px 0 rgba(0, 0, 0, 0.2)'
            }}
            itemStyle={{ color: theme.textColor }}
            labelStyle={{ color: theme.textColorLighter }}
            wrapperStyle={{
              border: 0,
              borderRadius: 5,
              fontSize: '1.4rem',
              fontWeight: 600
            }}
          />

          <XAxis
            axisLine={false}
            dataKey={xAxisDataKey}
            dy={10}
            stroke={theme.textColorLighter}
            tickLine={false}
            {...{ fontSize: 14, fontWeight: 600 }}
          />

          <YAxis
            allowDecimals={false}
            axisLine={false}
            dx={-10}
            stroke={theme.textColorLighter}
            tickLine={false}
            width="auto"
            {...{ fontSize: 14, fontWeight: 600 }}
          />

          {yAxis.map((yaxis, i) => (
            <Line
              key={yaxis}
              activeDot={{
                fill: 'white',
                r: 4,
                stroke: lineColor[i],
                strokeWidth: 2
              }}
              dataKey={yaxis}
              dot={false}
              stroke={lineColor[i]}
              strokeWidth={2}
              type="monotone"
            />
          ))}
        </RechartsLineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LineChart;
